import { faMessageDots } from '@fortawesome/pro-regular-svg-icons';
import { BoxV2 as Box } from 'portal-commons';

import RcsSectionBlock from './RcsSectionBlock';

interface SampleMessagesSectionProps {
  messages: string[];
}

const SampleMessagesSection: React.FC<SampleMessagesSectionProps> = ({
  messages,
}) => {
  return (
    <RcsSectionBlock
      icon={faMessageDots}
      title="Sample Messages"
      showDivider={true}
      data-testid="campaignSampleMessages"
    >
      <Box
        as="ol"
        sx={{
          listStyle: 'decimal',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          paddingLeft: '25px',
          color: 't.black70',
          fontSize: 'H300',
          margin: 0,
          '& li': {
            paddingLeft: '8px',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-all',
            lineHeight: 'normal',
            width: '75%',
            '&::marker': {
              fontWeight: '600',
              color: 't.black70',
            },
          },
        }}
      >
        {messages.map((message, index) => (
          <li key={index}>{message}</li>
        ))}
      </Box>
    </RcsSectionBlock>
  );
};

export default SampleMessagesSection;
